import React from "react";
import Navbar from "../../components/navbar/Navbar";
import "../all css/immigrationsection.css";
import "../all css/educationloan.css";

const loan_img = require("../../assets/loan1.svg");
const loan_img1 = require("../../assets/loan2.svg");
const loan_img2 = require("../../assets/loan3.svg");
const loan_img3 = require("../../assets/loan4.svg");
const loan_img4 = require("../../assets/loan5.svg");
const loan_img5 = require("../../assets/loan6.svg");
const loan_img6 = require("../../assets/loan7.svg");

const allImmigrationBox = [
  {
    imgImmigration: loan_img,
    nameImmigration: "Credit Worthiness",
    contentImmigration:
      "Credit worthiness is a factor determined by evaluating a person’s credit history. Lenders check an individual's credit worthiness to determine his/her ability to repay the loan on time. This is done to minimize the risks associated with an education loan. Individuals with a clean credit history tend to get higher loan amounts and quicker approvals.",
  },
  {
    imgImmigration: loan_img1,
    nameImmigration: "Credit Score",
    contentImmigration: `Credit score plays a crucial role in determining your eligibility for loans, credit cards etc. Timely payment of credit card bills & EMIs on existing loans reflects positively on your credit score and help in improving your chances of getting an education loan.`,
  },
  {
    imgImmigration: loan_img2,
    nameImmigration: "Value of Collateral",
    contentImmigration: `Education loan lenders generally ask for collateral for loans exceeding Rs.7.5 Lakh to minimize their risk. In case a borrower fails to pay the loan, the collateral is used to recover the loan amount. Applicants who offer collateral of good value stand a better chance of getting high amount education loans.`,
  },
  {
    imgImmigration: loan_img3,
    nameImmigration: "Academic History of Student",
    contentImmigration: `The academic track record of a student plays a very important role while sanctioning the education loan. Meritorious students with an exceptional academic background exhibit seriousness towards their education & career and hence, have a better chance of getting well-paying jobs in the future.`,
  },
];

function EducationLoanAssistanceSection(props) {
  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="educationloanassistance" />
      </div>
      <section className="loan_main_section_container">
        <div className="section_immigration_under_container">
          <div className="section_header_for_loan_contianer">
            <p className="title_text_immigration">
              EDUCATION LOAN <br />
              ASSISTANCE
            </p>
            <p className="subtitle_text_immigration">
              Get yout immigration process simplified by getting in touch with
              us. We at DWEC comprises a very talented team of lawyers across
              the globe for your assistance.
            </p>
          </div>
        </div>
      </section>
      <div className="main_border_container">
        <div class="container">
          <div className="margin_container">
            <p className="highlight_text_counselling">
              DWEC, offers education loan assistance to assist you during the
              whole procedure
            </p>
          </div>
          <p className="highlight_text_extra_text">
            Want to study abroad? But your current budget does not support the
            idea? We can aid you in taking an education loan to study abroad. We
            have partnerships with leading financial institutions to help
            students get the best loan at most favorable terms. We assist
            students in documentation, processing and disbursal of loan. <br />{" "}
          </p>
          <div className="margin_container">
            <p className="highlight_text_extra_text">
              Most lenders have a maximum limit of Rs 10 Lakh for studies within
              India while the maximum limit on education loans for overseas
              studies is Rs 20 Lakh. Nowadays most of the NBFCs are offering
              loan up to the complete cost of education. Banks generally fund
              75% to 90% of the educational expenses as a loan. NBFCs like HDFC
              Credila provide loans up to 100% of educational finance. In some
              cases, NBFCs may sanction a loan amount higher than the specified
              limit if certain conditions are met.
            </p>
          </div>

          <p className="highlight_text_counselling">
            The maximum amount of loan an applicant is eligible for is
            determined by a variety of factors. These factors include, among
            others:
          </p>
        </div>

        <div className="four_box_all_container">
          {allImmigrationBox.map((perImmigration) => {
            return (
              <div className="each_box_immigration_container">
                <div className="img_container_immigration">
                  <img
                    src={perImmigration.imgImmigration.default}
                    alt="passport_img"
                  />
                </div>
                <p className="title_for_each_box_text">
                  {perImmigration.nameImmigration}
                </p>

                <p className="subtitle_for_each_box_text">
                  {perImmigration.contentImmigration}
                </p>
              </div>
            );
          })}
          <div className="each_box_immigration_container">
            <div className="img_container_immigration">
              <img src={loan_img4.default} alt="passport_img" />
            </div>
            <p className="title_for_each_box_text">
              Eligibility for education loan
            </p>

            <p className="subtitle_for_each_box_text">
              <ul className="highlight_text_counselling">
                <li>The applicant must be a citizen of India.</li>
                <li>The applicant must be at least 18 year old.</li>
                <li>The applicant must have a good academic background.</li>
                <li>
                  Applicant should have procured admission in a recognized
                  foreign university or institution.
                </li>
              </ul>
            </p>
          </div>
        </div>

        <div className="">
          <p className="highlight_text_counselling">
            Types of education loans:
          </p>
          <p className="highlight_text_extra_text">
            There are two types of education loans. Both the loans can be
            provided by public sector banks, private sector banks and NBFC’s on
            varying interests.
          </p>
        </div>

        <div className="four_box_all_container">
          <div className="each_box_immigration_container">
            <div className="img_container_immigration">
              <img src={loan_img5.default} alt="passport_img" />
            </div>
            <p className="title_for_each_box_text">Secured loan</p>

            <p className="subtitle_for_each_box_text">
              A secured loan is given to an applicant who is eligible to pay for
              collateral. These loans have low interest rates & require time for
              processing. But these loans have comparatively higher chances of
              approval and does not require applicant to repay the amount during
              his/her study period.
            </p>
          </div>
          <div className="each_box_immigration_container">
            <div className="img_container_immigration">
              <img src={loan_img6.default} alt="passport_img" />
            </div>
            <p className="title_for_each_box_text">Unsecured loans</p>

            <p className="subtitle_for_each_box_text">
              An unsecured loan does not require the applicant to pay collateral
              for the loan. But these loans have higher interest rates. The good
              thing about these kinds of loan is their processing time is really
              quick. Aside the advantage, unsecured loan has least chances of
              getting approval and requires the applicant to repay the amount
              during his/her study period.
            </p>
          </div>
        </div>

        <div className="margin_container">
          <p className="highlight_text_counselling">
            How we can help you in acquiring an education loan?
          </p>
          <p className="highlight_text_extra_text">
            We take into consideration the amount of time and energy one has to
            spend in order to take an education loan. So, we at DWEC, bring you
            a hassle free application process. The steps of the same are as
            follows:
          </p>
          <div className="margin_container">
            <ul className="highlight_text_counselling">
              <li>
                Once our client completes the application process, we match your
                profile to offer you the best loan according to your eligibility
                and requirement.
              </li>
              <li>
                Next, we finalize the lender with you and provide you a list of
                documents required. We then, take care of the whole loan process
                and documentation.
              </li>
              <li>
                Subsequently, we assist you in disbursal of loan to the
                university as per the schedule.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default EducationLoanAssistanceSection;
